<script lang="ts">
	import Spam from './spam.svg.svelte';

	interface Props {
		className?: string;
		accept?: boolean;
	}

	let { className = '', accept = true }: Props = $props();
</script>

<Spam {accept} {className} />
